"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _get = _interopRequireDefault(require("./get"));

var _keyArray = _interopRequireDefault(require("./keyArray"));

var _default = (0, _unmutable.default)({
  name: 'entriesReverse',
  // $FlowFixMe - using * as flow cannot recognise Symbol.iterator as being @@iterator (see https://github.com/facebook/flow/issues/1163)
  all: function all() {
    return function (value) {
      var _ref;

      var keys = (0, _keyArray.default)()(value);
      var counter = keys.length - 1;
      return _ref = {}, (0, _defineProperty2.default)(_ref, Symbol.iterator, function () {
        return this;
      }), (0, _defineProperty2.default)(_ref, "next", function next() {
        return keys.hasOwnProperty(counter) ? {
          value: [keys[counter], (0, _get.default)(keys[counter--])(value)],
          done: false
        } : {
          done: true
        };
      }), _ref;
    };
  }
});

exports.default = _default;